import React, { useState, useEffect } from 'react';
import MacTable from '../ui/MacTable';
import VisitLink from '../ui/VisitLink';
import '../../styles/findings.css';

// Import utilities
import { getData } from '../../utils/dataUtils';
import { formatDate } from '../../utils/dateUtils';
import { sortByDate } from '../../utils/sortUtils';
import { TABLE_HEADERS } from '../../utils/constants';

const ContributionSection = () => {
  const [contributions, setContributions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadContributions = async () => {
      try {
        setLoading(true);
        
        try {
          // Get data from local JSON file instead of API
          const data = getData('contributions');
          // Sort by date (newest first)
          const sortedData = sortByDate(data);
          setContributions(sortedData);
        } catch (err) {
          setError('Failed to load contribution data.');
        }
        
        setLoading(false);
      } catch (err) {
        setError('An unexpected error occurred.');
        setLoading(false);
      }
    };

    loadContributions();
  }, []);

  const renderRow = (item, index) => (
    <tr key={item.id || index}>
      <td>
        {item.url ? 
          <a href={item.url} target="_blank" rel="noopener noreferrer">{item.title}</a> : 
          item.title
        }
      </td>
      <td>{formatDate(item.date)}</td>
      <td>
        {item.url && (
          <VisitLink url={item.url} placeholder="View" />
        )}
      </td>
    </tr>
  );

  if (loading) {
    return (
      <section id="contributions">
        <div className="container">
          <h2 className="topic">Public Contribution</h2>
          <div className="loading">Loading contributions...</div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="contributions">
        <div className="container">
          <h2 className="topic">Public Contribution</h2>
          <div className="error">{error}</div>
        </div>
      </section>
    );
  }

  return (
    <section id="contributions">
      <div className="container">
        <h2 className="topic">Public Contributions</h2>
        <MacTable
          title=""
          headers={TABLE_HEADERS.CONTRIBUTIONS}
          data={contributions}
          renderRow={renderRow}
        />
      </div>
    </section>
  );
};

export default ContributionSection;
